export default {
  SET_TEMPLATE_DATA(state, templateData) {
    state.templates = templateData;
  },
  SET_TEMPLATE_RECORDS(state, totalTemplates) {
    state.totalTemplates = totalTemplates;
  },
  SET_CURRENT_PAGE(state, data) {
    state.templates.currentPage = data;
  },
};
